import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'app-info-dialog',
    templateUrl: './info-dialog.component.html',
    standalone: false
})
export class InfoDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: { infoText: string }) { }

    get infoText(): string {
        if (!this.data.infoText) {
            return '';
        }
        return this.data.infoText.split('.')
            .map(sentence => sentence.trim())
            .filter(sentence => sentence.length > 0)
            .join('.<br/>');
    }
}
